export default "__VITE_ASSET__BmnUvTVg__"